import { useSelector, useDispatch } from 'react-redux';
import { getQuotes } from '../actions/quotes';
import { dateToString, toTitleCase } from '../utils/functions';
import { listSelector } from '../selectors';
import { quotesIndexName, agentType, customerType } from '../utils/variables';
// import { loadQuotesCount } from '../utils/variables';

const useQuoteData = ({ infiniteScroll = false } = {}) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const selectedClient = useSelector(state => state.auth.selectedClient);
  const usertype = useSelector(state => state.auth.usertype);
  const masterId =
    auth.usertype === agentType
      ? selectedClient?.clientNumber
      : auth?.user?.customer?.masterId;
  const c360Id =
    auth.usertype === agentType ? selectedClient?.c360Id : auth?.user?.customer?.id;
  const email = selectedClient?.email || selectedClient?.primaryEmail;
  const agentId = auth?.user?.agent?.id || '';
  const defaultOptions = useSelector(state =>
    listSelector.listOptions({ state, name: quotesIndexName, infiniteScroll }),
  );

  return ({ nextStartIndex, nextItemCount, nextScrollCount, actionIndex }) => {
    const body = {
      masterId,
      c360Id,
      agentId: agentId || undefined,
      usertype: usertype || customerType,
      // limit: defaultOptions?.itemCount,
      // offset: defaultOptions?.startIndex,
      // fromDate: dateToString(defaultOptions?.startDate, 'yyyy-MM-dd'),
      // toDate: dateToString(defaultOptions?.endDate, 'yyyy-MM-dd'),
      // lob: toTitleCase(defaultOptions?.lob?.toString()), // defaultOptions?.lob,
      nextItemCount,
      nextScrollCount,
      nextStartIndex,
      email,
    };

    // cellMeasurerCache.clearAll();
    // listRef.current.recomputeRowHeights();
    // listRef.current.forceUpdate();

    // if (allRows && allRows.length > 0 && startIndex > 0) {
    //   return dispatch(getQuotes.getNextQuotesAction(body));
    // }

    return dispatch(getQuotes.getQuotesAction(body)).catch(err => {
      // console.log('err: ', err);
    });
  };
};
export default useQuoteData;
